import { createApp } from 'vue';
import ShareView from '../../talent/ShareView.vue'
const appElements = document.querySelectorAll('.vue-tlnt-share-view')

Array.from(appElements).forEach(element => {
  createApp(ShareView).mount(element);
});